export function truncateDecimals(value: string | number, decimals: number, stripZeros = false) {
  const valueString = value.toString()

  if (valueString.includes('.')) {
    const [integer, fraction] = valueString.split('.', 2)

    if (fraction.length === 0) return `${integer}.`
    if (/^0+$/.test(fraction)) return `${integer}.${fraction}`

    const truncated = stripZeros ? fraction.slice(0, decimals).replace(/0+$/, '') :fraction.slice(0, decimals)
    return `${integer}.${truncated}`
  }

  return valueString
}
